// extracted by mini-css-extract-plugin
export var container = "_as-1";
export var cornerButtonContainer = "_as-5";
export var disabled = "_as-2";
export var fileContainer = "_as-4";
export var hiddenInput = "_as-3";
export var widthContainer = "_as-0";